/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as LoadingSpinnerDefault } from './loading-spinner-default.story';
export { default as LoadingSpinnerSizes } from './loading-spinner-sizes.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import LoadingSpinnerDefaultSourceRaw from './loading-spinner-default.story?raw';
import LoadingSpinnerSizesSourceRaw from './loading-spinner-sizes.story?raw';

export const LoadingSpinnerDefaultSource = removeLicenseHeader(
  LoadingSpinnerDefaultSourceRaw,
);
export const LoadingSpinnerSizesSource = removeLicenseHeader(
  LoadingSpinnerSizesSourceRaw,
);
